import { Container, Heading, Link, Box } from '@hover/blueprint';
import React from 'react';
import { Link as GatsbyLink } from 'gatsby';

const ChooseThePlanHeader: React.FC = () => (
  <Container
    pt={{ base: 1000, tablet: '110px', desktop: 1000 }}
    mb={{ base: '88px', tablet: '80px', desktop: '88px' }}
    maxW="880px"
    px={500}
  >
    <Heading
      textAlign="center"
      size={{ base: 500, tablet: 600, desktop: 700 }}
      isLight
      marginBottom={{ base: 500, desktop: 600 }}
    >
      Choose the plan that best fits your team
    </Heading>
    <Box
      mx="auto"
      flexDir="column"
      alignItems="center"
      maxW={{ base: '100%', tablet: '90%' }}
    >
      <Heading textAlign="center" size={{ base: 300, tablet: 500 }} isDisplay>
        Take a look at our full feature breakdown.
      </Heading>
      <Heading textAlign="center" size={{ base: 300, tablet: 500 }} isDisplay>
        Still wonder which is best for your team?{' '}
        <Link
          as={GatsbyLink}
          color="primary.600"
          to={`${process.env.GATSBY_V2_PREFIX}/contact`}
          fontWeight={600}
        >
          We’re here to help.
        </Link>
      </Heading>
    </Box>
  </Container>
);

export default ChooseThePlanHeader;
